import { useCallback, useState } from 'react';

export const useBooleanState = (initialState: boolean): [boolean, () => void] => {
  const [state, setState] = useState(initialState);

  const switchState = useCallback(() => {
    setState((prevState) => !prevState);
  }, []);

  return [state, switchState];
};
